import React, { useEffect, useState, useMemo } from 'react';
import { Modal, CloseButton, Button } from 'react-bootstrap';
import Required from '../../../Required';
import searchIcon from '../../../../../img/finder.svg';
import style from './TabResults.module.less';
import useDebounce from '../../../../hooks/useDebounce';
import useAPI from '../../../../hooks/useAPI';
import { getName } from '../../../../helpers/passport';
import LoadingTable from '../../../table/LoadingTable';

export default function PersonsInChargeModal({
  show,
  onHide,
  onSave,
  value,
}) {
  const [inputValue, setInputValue] = useState('');
  const [respOptions, setRespOptions] = useState([]);
  const [selected, setSelected] = useState([]);
  const [isLoading, setIsLoading] = useState(false)

  const api = useAPI();

  const debouncedName = useDebounce(inputValue, 500);

  useEffect(async () => {
    if (debouncedName) {
      setIsLoading(true)
      const persons = await api.get(`/users/employees?name=${debouncedName}`);
      setRespOptions(
        persons.reduce((acc, curr) => !acc.some(person => person[person.id ? 'id' : 'employeeId'] === curr[curr.id ? 'id' : 'employeeId']) ? [...acc, curr] : acc, []).map((person) => ({
          label: getName(person),
          value: person,
        })),
      );
    }
  }, [debouncedName]);

  const options = useMemo(
		() => {
      setIsLoading(false)
			return [...selected.map(person => ({
				label: getName(person),
				value: {...person, selected: true},
			})),
			...respOptions.filter(opt =>
				!selected.some(
					person => person[typeof person.id === 'string' ? 'id' : person.userId ? 'userId' : 'employeeId'] === opt.value[typeof opt.value.id === 'string' ? 'id' : opt.value.userId ? 'userId' : 'employeeId']
				)
			),
    ].filter(opt => !opt.value.projId)
  },
		[respOptions, selected]
	)   

  useEffect(() => {
    setSelected(value.personsInCharge || []);
    if(!show){
      setRespOptions([])
      setInputValue('')
    }
  }, [show]);

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header>
        <Modal.Title>
          Ответственный
          {' '}
          <Required />
        </Modal.Title>
        <CloseButton className="ms-auto" onClick={onHide} />
      </Modal.Header>
      <Modal.Body>
        <div className={style['modal-search']}>
          <img src={searchIcon} className={style['modal-searchIcon']} />
          <input
            className={style['modal-input']}
            placeholder="ФИО"
            onChange={(event) => setInputValue(event.target.value)}
            value={inputValue}
          />
          <button
            className="btn-close ms-auto"
            onClick={() => setInputValue('')}
          />
        </div>
        <ul className={style['modal-options']}>
          {options.map((opt, i) => (
            <li
              key={opt.value?.id || i}
              className={style['modal-option']}
              onClick={() => {
                if(!opt.value.projId){
                  setSelected((prevState) =>
                    (prevState.some(person => person[typeof person.id === 'string' ? 'id' : person.userId ? 'userId' : 'employeeId'] === opt.value[typeof opt.value.id === 'string' ? 'id' : opt.value.userId ? 'userId' : 'employeeId'])
                      ? [
                        ...prevState.filter(
                            person => person[typeof person.id === 'string' ? 'id' : person.userId ? 'userId' : 'employeeId'] !== opt.value[typeof opt.value.id === 'string' ? 'id' : opt.value.userId ? 'userId' : 'employeeId'],
                          ),
                        ]
                      : [...prevState, {...opt.value, selected: true}]))
                }
              }}
                style={{backgroundColor: opt.value.selected ? '#DCE7FF' : '#fff'}}
            >
              <input
                type="checkbox"
                checked={opt.value.selected}
              />
              <p>{opt.label}</p>
            </li>
          ))}
        </ul>
        <LoadingTable loadingObject={{isLoading}} spinnerStyle={{marginTop: 16}}/>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={onHide}>Отмена</Button>
        <Button onClick={() => {
          onSave(selected);
          onHide();
        }}
        >
          Сохранить

        </Button>
      </Modal.Footer>
    </Modal>
  );
}
